import HttpService from './HttpService'

const _http = new HttpService()
export default {
  show: (page, eventId = null, options = null) => {
    let _parans = `?page=${page - 1}`;
    if(eventId){
      _parans += `&data.event_id=${eventId}`;
    }
    if (options) {
      if(options.search) {
        _parans += `&search=${options.search}`;
      }
      if (options.orderByKey) {
        _parans += `&order_by=${options.orderByKey}`
      }
      if (options.ascOrDes) {
        _parans += '&asc'
      }
    }
    return _http.get(`/api/sub-events${_parans}`)
  },
  find: (id) => {
    return _http.get(`/api/sub-events/${id}`)
  },
  create: (payload) => {
    return _http.post('/api/sub-events', payload)
  },
  update: (payload) => {
    return _http.put('/api/sub-events', payload)
  },
  delete: (id) => {
    return _http.delete(`/api/sub-events/${id}`)
  }
}